import React, { Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import { red } from '@material-ui/core/colors';

import {
  noop,
  sortBy,
} from 'lodash';

import {
  Badge,
  Toggle,
} from 'components';

import { formatPrice } from 'helpers/utils';
import EditItemButton from '../EditItemButton';
import ProductItemImage from '../ProductItemImage';

class GridView extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
  };

  static propTypes = {
    id: PropTypes.number,
    info: PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
    isFarm: PropTypes.bool.isRequired,
    isMarketPlace: PropTypes.bool.isRequired,
    imageRequesting: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool,
    readOnlyForPermission: PropTypes.bool,

    onUploadImage: PropTypes.func.isRequired,
    onRemoveImage: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    reloadStore: PropTypes.func.isRequired,
    threshold: PropTypes.string,
    onItemImageClick: PropTypes.func,
    updateStateData: PropTypes.func.isRequired,
    isRetailPage: PropTypes.bool,
  };

  static defaultProps = {
    id: null,
    info: [],
    readOnly: false,
    readOnlyForPermission: false,
    threshold: 'md',
    onItemImageClick: noop,
    isRetailPage: false,
  };

  state = {
    storeData: [],
  };

  componentWillMount() {
    const { info } = this.props;
    this.setState({ storeData: info });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.info !== nextProps.info) {
      this.setState({ storeData: nextProps.info });
    }
  }

  getContent = (item) => {
    const {
      formatMessage,
      id,
      isFarm,
      isMarketPlace,
      imageRequesting,
      readOnly,
      readOnlyForPermission,
      reloadStore,
      onUploadImage,
      onRemoveImage,
      updateStateData,
      isRetailPage,
    } = this.props;

    const image = item.image || null;
    const sourceApproved = !isMarketPlace && item.storeItemId && (
      <span
        className={`status-dot ${item.sourceApproved ? 'success' : 'failure'}`}
        title={formatMessage(`This Item has been Toggled-${item.sourceApproved ? 'On' : 'Off'}`)}
      />
    );
    const content = (
      <div className="content">
        {sourceApproved}
        {!readOnly && (
          <Fragment>
            <div className="product" style={{width:'70%'}}>
              <div>
                {
                  item.productData.name
                }
              </div>
              <div>
                {
                  item.productData.subname
                }
              </div>
            </div>
            <div className="photo-upload-and-edit">
        
              <div className="photo-upload-button">
                <ProductItemImage
                  disabled={readOnlyForPermission}
                  onUpload={onUploadImage}
                  onRemove={onRemoveImage}
                  image={image}
                  info={item}
                  isGrid
                  reloadStore={reloadStore}
                  requesting={imageRequesting}
                  title={formatMessage('Add Photo')}
                />
              </div>
              <div className="edit-button">
                <EditItemButton
                  contactId={id}
                  info={item}
                  isApproved={item.approved}
                  title={formatMessage('Edit')}
                  updateStateData={(data, ...args) => updateStateData(
                    this,
                    {
                      ...data,
                      noDispatch: true,
                    },
                    ...args,
                  )}
                  reloadStore={reloadStore}
                  isRetailPage={isRetailPage}
                />
              </div>
            </div>
          </Fragment>
        )}
      </div>
    );
    return content;
  }

  getUoms = (item) => {
    const {
      isFarm,
    } = this.props;
    const uoms = sortBy(item.packrows, 'count');
    const uoms_section = (
      <div className="uoms">
        {
          uoms.map((uom, index) => (
            <div key={index} className="uom">
              <span>{`${uom.count} ${uom.uom} ${uom.pack}`}</span>
              <span>
                {
                  `${!isFarm ? `$${formatPrice(((uom.cost * (100 - (uom.discount || 0))) / 100))}/` : ''}$${formatPrice(uom.price)}`
                }
              </span>
            </div>
          ))
        }
      </div>
    );

    return uoms_section;
  }

  toggle = (toggled, id) => {
    const { updateStateData } = this.props;

    setTimeout(() => {
      updateStateData(this, { approved: toggled, noDispatch: true }, id);
    }, 100);
  }

  render() {
    const {
      formatMessage,
      readOnly,
      readOnlyForPermission,
      threshold,
      onItemImageClick,
    } = this.props;
    const { storeData } = this.state;
    const styles = {
      gridList: {
        display: 'flex',
        flexWrap: 'wrap',
        overflowY: 'auto',
        width: '100%',
      },
    };

    return (
      <div className={`d-${threshold}-down-none`} style={{ width: '100%' }}>
        <GridList
          cellHeight={220}
          cols={4}
          style={styles.gridList}
        >
          {
            storeData.map((item) => {
              const toggler = null;
              return (
                <GridListTile
                  className="grid-title"
                  key={item.id}
                  style={{
                    height: 220,
                    fontSize: 13,
                    padding: 1,
                  }}
                >
                  <img
                    src={item.image || ''}
                    className="item-image"
                    alt=""
                    style={{ cursor: 'pointer' }}
                    onClick={readOnly ? () => onItemImageClick(item) : noop}
                  />
                  {
                    this.getContent(item)
                  }
                  <GridListTileBar
                    actionIcon={readOnly ? toggler : (
                        item.productData.approved === false ? (
                          <Badge type="pending">
                            {formatMessage('Pending')}
                          </Badge>
                        ) : toggler
                      )
                    }
                    style={{
                      color: '#fff',
                    }}
                    title={this.getUoms(item)}
                  />
                </GridListTile>
              );
            })}
        </GridList>
      </div>
    );
  }
}

export default GridView;
